import { shaderMaterial } from "@react-three/drei"
import { extend } from "@react-three/fiber"
import * as THREE from "three"

import raw from "raw.macro"

const firefliesFragmentShader = raw("./shaders/dust/fragment.glsl")
const firefliesVertexShader = raw("./shaders/dust/vertex.glsl")

const DustShaderMaterial = shaderMaterial(
    {
        uTime: 0,
        uPixelRatio: Math.min(window.devicePixelRatio, 2),
        uSize: 50,
        uColor: new THREE.Color("#c2b280"),
    },
    // vertex shader
    `${firefliesVertexShader}
   
    
    `,
    // fragment shader
    `${firefliesFragmentShader}
    `
)

extend({ DustShaderMaterial })
